import useOnceWhen from './useOnceWhen';

const useOnce = (fire: () => void) => {
  useOnceWhen(true, fire);
};

export default useOnce;
